import { useState } from 'react'

const useMinTotalTurnover = () => {
  const [minTotalTurnover, setMinTotalTurnover] = useState<number>()

  const loadMinTotalTurnover = () => {
    fetch('https://elama.ru/agency-api/commission/conditions')
      .then(response => response.json())
      .then(data => {
        setMinTotalTurnover(data.minTurnover.amount / 100)
      })
  }

  return { minTotalTurnover, loadMinTotalTurnover }
}

export default useMinTotalTurnover
